export function strEquals(a,b){
  return `${a}` === `${b}`
}

export function deepClone(object){
  return JSON.parse(JSON.stringify(object))
}

export function deserializeObject(item){
  return Object.fromEntries(
    Object.entries(item).map(([key,value])=>{
      try{
        value = JSON.parse(value)
      }catch (e) { /**/ }
      return [key,value]
    })
  )
}

export function getRandomIntArray(size){
  const dummyArray = Object.keys(new Array(size).fill(0))
  return [...new Array(size)].map(() => {
    return dummyArray.splice(Math.floor(Math.random() * dummyArray.length),1)[0]
  })
}

export function downloadAsFile(text, filename){
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.href = 'data:application/json;charset=utf-8,' + encodeURIComponent(text)
  a.download = filename;
  a.click();
  document.body.removeChild(a);
}
